export const schedule = {
    user: {
        label: "Praticien en charge de cette ½ journée",
        title: "Praticien qui recevra les patients lors de cette ½ journée"
    },
    morning: "Matin",
    afternoon: "Après-midi",
    closed: "Fermé"
}